<template>
  <div class="mb-5">
    <v-card flat outlined :loading="isMainLoading || isLoading" min-height="30">
      <v-card-title class="flex" style="justify-content: flex-start;">
        <div>{{ $t('product.title') }}</div>
      </v-card-title>
      <v-card-text>
        <div class="sh-db">
          <div class="dashboard">
            <div class="dashboard-header">
              <div class="head">{{ $t('product.all_product') }}</div>
              <div class="tail">
                <div>{{ $t('product.product_information') }}</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>{{ $t('product.product_information_from_all_project') }}</div>
                </v-tooltip>
              </div>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('product.all_product_in_system') }}</div>
              <template v-if="!isLoading && dataProductPrepare">
                <div class="h-number">
                  {{ dataProductPrepare.count || 0 | arabic }}
                  <span>{{ $t('product.title') }}</span>
                </div>
                <div class="h-number">
                  {{ dataProductPrepare.countType || 0 | arabic }}
                  <span>{{ $t('type') }}</span>
                </div>
              </template>
              <div v-else class="pt-5">{{ $t('noinfo') }}</div>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('product.latest_product') }}</div>
              <template v-if="!isLoading && dataProductPrepare && dataProductPrepare.lastProduct">
                <div class="h-text">{{ dataProductPrepare.lastProduct.name }}</div>
                <div style="margin-top:7px;">{{ $t('product.when', { data: dataProductPrepare.lastProduct.createdAtFormat }) }}</div>
              </template>
              <div v-else class="pt-5">{{ $t('noinfo') }}</div>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('product.latest_product_category') }}</div>
              <template v-if="!isLoading && dataProductPrepare && dataProductPrepare.lastProductCategory">
                <div class="h-text">{{ dataProductPrepare.lastProductCategory.name }}</div>
                <div style="margin-top:7px;">{{ $t('product.when', { data: dataProductPrepare.lastProductCategory.createdAtFormat }) }}</div>
              </template>
              <div v-else class="pt-5">{{ $t('noinfo') }}</div>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
          </div>
        </div>
        <div class="sh-db">
          <div class="dashboard">
            <div class="dashboard-header">
              <div class="head">{{ $t('product.product_in_market') }}</div>
              <div>{{ $t('area.current_stall') }}</div>
              <div class="tail">
                <div>{{ $t('area.stall_data') }}</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>{{ $t('area.stall_data_from_current_stall') }}</div>
                </v-tooltip>
              </div>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('product.product_in_market_count') }}</div>
              <template v-if="!isLoading && dataAreaPrepare">
                <div class="h-number">
                  {{ dataAreaPrepare.countProduct.length > 0 ? dataAreaPrepare.countProduct.length - 1 : 0 | arabic }}
                  <span>{{ $t('product.title') }}</span>
                </div>
                <div class="h-number">
                  {{ dataAreaPrepare.countProductByType.length > 0 ? dataAreaPrepare.countProductByType.length - 1 : 0 |
                    arabic }}
                  <span>{{ $t('type') }}</span>
                </div>
              </template>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('product.best_seller_product') }}</div>
              <template v-if="!isLoading && dataAreaPrepare && dataAreaPrepare.countProductTop">
                <div class="h-text">{{ dataAreaPrepare.countProductTop.name }}</div>
                <div>
                  {{ dataAreaPrepare.countProductTop.countArea || 0 | arabic }}
                  <span>{{ $t('area.space') }}</span>
                </div>
                <div>({{ dataAreaPrepare.countProductTop.percent || 0 | currency }}%)</div>
              </template>
              <div v-else class="pt-5">{{ $t('noinfo') }}</div>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('product.best_seller_product_type') }}</div>
              <template v-if="!isLoading && dataAreaPrepare && dataAreaPrepare.countProductByTypeTop">
                <div class="h-text">{{ dataAreaPrepare.countProductByTypeTop.name }}</div>
                <div>
                  {{ dataAreaPrepare.countProductByTypeTop.countArea || 0 | arabic }}
                  <span>{{ $t('area.space') }}</span>
                </div>
                <div>({{ dataAreaPrepare.countProductByTypeTop.percent || 0 | currency }}%)</div>
              </template>
              <div v-else class="pt-5">{{ $t('noinfo') }}</div>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('noitem') }}</div>
              <template v-if="!isLoading && dataAreaPrepare && dataAreaPrepare.countProductObject">
                <div class="h-number">
                  {{ dataAreaPrepare.countProductObject.noData.count || 0 | arabic }}
                  <span>{{ $t('area.space') }}</span>
                </div>
                <div>({{ dataAreaPrepare.countProductObject.noData.percent || 0 | currency }}%)</div>
              </template>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
          </div>
        </div>

        <div class="gh">
          <div class="in">
            <div>
              <div class="text-center mt-5">
                <v-icon class="mr-1">mdi-chart-pie</v-icon>{{ $t('product.top_five_product_in_market') }}
              </div>
              <div class="monthly-income-box">
                <div class="pie-chart-box">
                  <canvas id="pie-chart-products" v-show="dataAreaPrepare && dataAreaPrepare.productTop5.length"></canvas>
                  <div v-show="dataAreaPrepare && dataAreaPrepare.productTop5.length == 0" class="no-data">
                    {{ $t('product.no_product') }}</div>
                </div>
                <div class="payment-method-box" v-if="dataAreaPrepare">
                  <div>
                    <b>{{ $t('product.top_five_product_in_market_title') }}</b>
                  </div>
                  <div v-for="(product, index) in dataAreaPrepare.productTop5" :key="product.objectId">
                    {{ index + 1 }}. {{ product.name }} {{ product.countArea | arabic }} {{ $t('area.space') }}
                    <span>({{ product.percent | currency }}%)</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="b">
              <div class="text-center mt-5">
                <v-icon class="mr-1">mdi-chart-pie</v-icon>{{ $t('product.top_five_product_in_market_category') }}
              </div>
              <div class="monthly-income-box">
                <div class="pie-chart-box">
                  <canvas id="pie-chart-product-category"
                    v-show="dataAreaPrepare && dataAreaPrepare.productCategoryTop5.length"></canvas>
                  <div v-show="dataAreaPrepare && dataAreaPrepare.productCategoryTop5.length == 0" class="no-data">
                    {{ $t('product.no_product') }}</div>
                </div>
                <div class="payment-method-box" v-if="dataAreaPrepare">
                  <div>
                    <b>{{ $t('product.top_five_product_in_market_category_title') }}</b>
                  </div>
                  <div v-for="(product, index) in dataAreaPrepare.productCategoryTop5" :key="product.objectId">
                    {{ index + 1 }}. {{ product.name }} {{ product.countArea | arabic }} {{ $t('area.space') }}
                    <span>({{ product.percent | currency }}%)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import SelectMonthYear from "@/components/SelectMonthYear.component";
Chart.register(ChartDataLabels);
let pieChartProducts, pieChartProductCategorys;
export default {
  name: "OverallProduct",
  props: {
    isMainLoading: Boolean
  },
  components: { SelectMonthYear },
  computed: {
    ...mapGetters({
      // invoices: "invoice/getInvoiceOverallMonthly"
    })
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      isMountedCheckPieChart: false,
      isMountedCheckPieChart2: false,
      dataAreas: null,
      dataAreaPrepare: null,
      dataProducts: null,
      dataProductPrepare: null
    };
  },
  mounted() {
    this.isMountedCheckPieChart = true;
    this.isMountedCheckPieChart2 = true;
    this.initData();
  },
  methods: {
    async initData() {
      this.isLoading = true;
      try {
        this.dataAreas = await this.getOverallAreas();
        this.dataAreaPrepare = await this.prepareDataOverviewArea(
          this.dataAreas
        );
        this.dataProducts = await this.getOverallProducts();
        this.dataProductPrepare = await this.prepareDataOverviewProduct(
          this.dataProducts
        );
        this.initPieChartProducts(this.dataAreaPrepare);
        this.initPieChartProductCategorys(this.dataAreaPrepare);
        this.isLoading = false;
      } catch (error) {
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        this.isLoading = false;
      }
    },
    getOverallAreas() {
      return this.$store.dispatch("area/getOverallAreas", {
        projectId: this.projectId,
        marketId: this.marketId
      });
    },
    getOverallProducts() {
      return this.$store.dispatch("product/getProducts", {
        projectId: this.projectId,
        marketId: this.marketId
      });
    },
    prepareDataOverviewArea(dataAreas) {
      let dataRes = {
        monthYearStay: {},
        monthYearStayArr: [],
        count: 0,
        countOccupied: 0,
        percentOccupied: 0,
        countContract: 0,
        countAreaBooking: 0,
        countContractAreaBooking: 0,
        countNumOfAreaBooking: 0,
        lastMonth: "",
        lastMonthData: undefined,
        size: 0,
        countProductObject: {
          noData: { count: 0, name: this.$t('no_specify_product'), percent: 0, countArea: {} }
        },
        countProductByTypeObject: {
          noData: { count: 0, name: this.$t('no_specify_product'), percent: 0, countArea: {} }
        },
        countProduct: [],
        countProductByType: [],
        countProductTop: null,
        countProductByTypeTop: null,
        productTop5: [],
        productCategoryTop5: []
      };

      if (dataAreas && dataAreas.length) {
        for (let dataArea of dataAreas) {
          dataRes.count++;
          dataRes.size += dataArea.size || 0;
          dataRes.countNumOfAreaBooking += dataArea.numOfAreaBooking || 0;
          if (dataArea.areaBooking || dataArea.contract) {
            dataRes.countOccupied++;
            if (dataArea.areaBooking && dataArea.contract) {
              dataRes.countContractAreaBooking++;
            }
            if (dataArea.contract) {
              dataRes.countContract++;
              let monthYearContract = dataArea.contract
                ? this.$moment(dataArea.contract.startDate.iso).format(
                  "MM/YYYY"
                )
                : "";
              if (!dataRes.monthYearStay[monthYearContract])
                dataRes.monthYearStay[monthYearContract] = {
                  countAreaBooking: 0,
                  countContract: 0,
                  count: 0
                };
              dataRes.monthYearStay[monthYearContract].countContract++;
              dataRes.monthYearStay[monthYearContract].count++;
            }
            if (dataArea.areaBooking) {
              dataRes.countAreaBooking++;
              let monthYearAreaBooking = dataArea.areaBooking
                ? this.$moment(dataArea.areaBooking.startDate.iso).format(
                  "MM/YYYY"
                )
                : "";

              if (!dataRes.monthYearStay[monthYearAreaBooking])
                dataRes.monthYearStay[monthYearAreaBooking] = {
                  countAreaBooking: 0,
                  countContract: 0,
                  count: 0
                };
              dataRes.monthYearStay[monthYearAreaBooking].countAreaBooking++;
              dataRes.monthYearStay[monthYearAreaBooking].count++;
            }
            if (dataArea.products && dataArea.products.length) {
              for (const product of dataArea.products) {
                if (!dataRes.countProductObject[product.objectId])
                  dataRes.countProductObject[product.objectId] = {
                    count: 0,
                    countArea: {},
                    percent: 0,
                    name: product.name
                  };
                dataRes.countProductObject[product.objectId].count++;
                dataRes.countProductObject[product.objectId].countArea[
                  dataArea.id
                ] = true;
                if (
                  product.productCategory && product.productCategory.objectId &&
                  !dataRes.countProductByTypeObject[
                  product.productCategory.objectId
                  ]
                ) {
                  dataRes.countProductByTypeObject[
                    product.productCategory.objectId
                  ] = {
                    count: 0,
                    countArea: {},
                    percent: 0,
                    name: product.productCategory.name
                  };
                }
                if (product.productCategory && product.productCategory.objectId) {
                  dataRes.countProductByTypeObject[
                    product.productCategory.objectId
                  ].count++;
                  dataRes.countProductByTypeObject[
                    product.productCategory.objectId
                  ].countArea[dataArea.id] = true;
                }
              }
            } else {
              dataRes.countProductObject.noData.count++;
              dataRes.countProductByTypeObject.noData.count++;

              dataRes.countProductObject.noData.countArea[dataArea.id] = true;
              dataRes.countProductByTypeObject.noData.countArea[
                dataArea.id
              ] = true;
            }
          }
        }
        for (const monthYear in dataRes.monthYearStay) {
          let dataTemp = dataRes.monthYearStay[monthYear];
          dataTemp.monthYear = monthYear;
          dataRes.monthYearStayArr.push(dataTemp);
        }
        for (const productObjectId in dataRes.countProductObject) {
          let dataTemp = dataRes.countProductObject[productObjectId];
          dataTemp.objectId = productObjectId;
          dataTemp.countArea = Object.keys(dataTemp.countArea).length;
          dataTemp.percent = (dataTemp.countArea / dataRes.countOccupied) * 100;
          dataRes.countProduct.push(dataTemp);
        }
        for (const productObjectId in dataRes.countProductByTypeObject) {
          let dataTemp = dataRes.countProductByTypeObject[productObjectId];
          dataTemp.objectId = productObjectId;
          dataTemp.countArea = Object.keys(dataTemp.countArea).length;
          dataTemp.percent = (dataTemp.countArea / dataRes.countOccupied) * 100;
          dataRes.countProductByType.push(dataTemp);
        }
        dataRes.monthYearStayArr.sort(
          (a, b) =>
            this.$moment(a.monthYear, "MM/YYYY") -
            this.$moment(b.monthYear, "MM/YYYY")
        );
        dataRes.countProduct.sort((a, b) => b.count - a.count);
        dataRes.countProductByType.sort((a, b) => b.count - a.count);
        dataRes.countProductTop = dataRes.countProduct[0];
        dataRes.countProductByTypeTop = dataRes.countProductByType[0];
        dataRes.productTop5 = dataRes.countProduct
          .filter(pd => !(pd.countArea == 0 && pd.name == this.$t('no_specify_product')))
          .slice(0, 5);
        dataRes.productCategoryTop5 = dataRes.countProductByType
          .filter(pd => !(pd.countArea == 0 && pd.name == this.$t('no_specify_product')))
          .slice(0, 5);

        let monthYearStop = dataRes.monthYearStayArr.length
          ? this.$moment(
            dataRes.monthYearStayArr[dataRes.monthYearStayArr.length - 1]
              .monthYear,
            "MM/YYYY"
          )
          : null;
        dataRes.lastMonthData =
          dataRes.monthYearStayArr[dataRes.monthYearStayArr.length - 1];
        dataRes.lastMonth = monthYearStop
          ? monthYearStop.format("MMMM YYYY")
          : "-";
        dataRes.percentOccupied = dataRes.countOccupied / dataRes.count;
      }
      return dataRes;
    },
    prepareDataOverviewProduct(dataProducts) {
      let dataRes = {
        count: 0,
        countType: 0,
        lastProduct: null,
        lastProductCategory: null,
        dataProductCategoryObject: {},
        dataProductCategory: [],
        dataProducts: []
      };
      for (let dataProduct of dataProducts) {
        dataRes.count++;
        dataProduct.createdAtFormat = this.$moment(
          dataProduct.createdAt
        ).format("DD MMM YYYY");
        dataRes.dataProducts.push(dataProduct);
        if (
          dataProduct.productCategory && dataProduct.productCategory.objectId &&
          !dataRes.dataProductCategoryObject[
          dataProduct.productCategory.objectId
          ]
        )
          dataRes.dataProductCategoryObject[
            dataProduct.productCategory.objectId
          ] = dataProduct.productCategory;
      }
      for (const productCategoryObjectId in dataRes.dataProductCategoryObject) {
        let dataTemp =
          dataRes.dataProductCategoryObject[productCategoryObjectId];
        dataTemp.createdAtFormat = this.$moment(dataTemp.createdAt).format(
          "DD MMM YYYY"
        );
        dataRes.countType++;
        dataRes.dataProductCategory.push(dataTemp);
      }
      dataRes.dataProducts = dataRes.dataProducts.sort(
        (a, b) => this.$moment(b.createdAt) - this.$moment(a.createdAt)
      );
      dataRes.dataProductCategory = dataRes.dataProductCategory.sort(
        (a, b) => this.$moment(b.createdAt) - this.$moment(a.createdAt)
      );
      dataRes.lastProduct = dataRes.dataProducts[0];
      dataRes.lastProductCategory = dataRes.dataProductCategory[0];
      return dataRes;
    },
    initPieChartProducts(dataRes) {
      let dataChart = {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          tooltips: {
            enabled: false
          },
          layout: {
            padding: {
              top: 40,
              left: 40,
              right: 40
            }
          },
          plugins: {
            title: {
              display: false,
              text: this.$t('product.top_five_product_in_market'),
              position: "top",
              fontSize: 16,
              fontColor: "#111",
              padding: 20
            },
            legend: {
              display: false,
              position: "bottom",
              labels: {
                boxWidth: 20,
                fontColor: "#111",
                padding: 15
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: (value, ctx) => {
                return (
                  ctx.chart.data.labels[ctx.dataIndex] + "\n" + value + " " + this.$t('area.space')
                );
              }
            }
          },
          responsive: true
        },
        plugins: [ChartDataLabels]
      };
      dataChart.data.datasets = [
        {
          label: "Products",
          data: [],
          backgroundColor: [
            "#e91e63",
            "#00e676",
            "#ff5722",
            "#1e88e5",
            "#ffd600"
          ],
          borderWidth: 0.5,
          borderColor: "#ddd"
        }
      ];
      for (const product of dataRes.productTop5) {
        if (!(product.name == this.$t('no_specify_product') && product.countArea == 0)) {
          dataChart.data.labels.push(product.name);
          dataChart.data.datasets[0].data.push(product.countArea);
        }
      }
      if (!pieChartProducts || this.isMountedCheckPieChart) {
        let ctx = document.getElementById("pie-chart-products");
        if (ctx) pieChartProducts = new Chart(ctx, dataChart);
        this.isMountedCheckPieChart = false;
      } else {
        pieChartProducts.data = dataChart.data;
        pieChartProducts.update();
      }
    },
    initPieChartProductCategorys(dataRes) {
      let dataChart = {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          tooltips: {
            enabled: false
          },
          layout: {
            padding: {
              top: 40,
              left: 40,
              right: 40
            }
          },
          plugins: {
            title: {
              display: false,
              text: this.$t('product.top_five_product_in_market_category'),
              position: "top",
              fontSize: 16,
              fontColor: "#111",
              padding: 20
            },
            legend: {
              display: false,
              position: "bottom",
              labels: {
                boxWidth: 20,
                fontColor: "#111",
                padding: 15
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: (value, ctx) => {
                return (
                  ctx.chart.data.labels[ctx.dataIndex] + "\n" + value + " " + this.$t('area.space')
                );
              }
            }
          },
          responsive: true
        },
        plugins: [ChartDataLabels]
      };
      dataChart.data.datasets = [
        {
          label: "Product Category",
          data: [],
          backgroundColor: [
            "#e91e63",
            "#00e676",
            "#ff5722",
            "#1e88e5",
            "#ffd600"
          ],
          borderWidth: 0.5,
          borderColor: "#ddd"
        }
      ];
      for (const productCategory of dataRes.productCategoryTop5) {
        if (
          !(
            productCategory.name == this.$t('no_specify_product') &&
            productCategory.countArea == 0
          )
        ) {
          dataChart.data.labels.push(productCategory.name);
          dataChart.data.datasets[0].data.push(productCategory.countArea);
        }
      }
      if (!pieChartProductCategorys || this.isMountedCheckPieChart2) {
        let ctx = document.getElementById("pie-chart-product-category");
        if (ctx) pieChartProductCategorys = new Chart(ctx, dataChart);
        this.isMountedCheckPieChart2 = false;
      } else {
        pieChartProductCategorys.data = dataChart.data;
        pieChartProductCategorys.update();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.monthly-income-box {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;

  .pie-chart-box {
    width: 300px;
    height: 300px;
    margin: 20px 20px 30px;
  }

  .payment-method-box {
    margin: 20px 20px 30px;

    div {
      margin-bottom: 7px;
    }

    span {
      font-size: 13px;
    }
  }
}

.yearly-income-box {
  margin: 20px 0;
  display: flex;
  justify-content: center;

  .bar-chart-box {
    width: 60vw;
    height: auto;
    min-height: 400px;
  }
}

.pie-chart-box .no-data,
.bar-chart-box .no-data {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  background: rgba(211, 211, 211, 0.281);
  border-radius: 20%;
}

.bar-chart-box .no-data {
  border-radius: 5px;
}

.sh-db {
  display: flex;
  justify-content: center;
  // flex-flow: row wrap;
  margin: 15px 0 25px;
  gap: 15px;

  .dashboard {
    display: flex;
    background: rgba(230, 230, 230, 0.35);
    border-radius: 15px;
    max-width: max-content;
    flex-wrap: wrap;

    .dashboard-header {
      padding: 25px;
      min-width: 202px;

      .head {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
      }

      .tail {
        display: inline-flex;
        font-style: italic;
        color: rgba(128, 128, 128, 0.527);
        align-items: center;

        i {
          margin-left: 2px;
          font-size: 15px;
          color: rgba(128, 128, 128, 0.527);
        }
      }

      .select-month-year {
        max-width: 200px;
        margin: 10px 0;
      }
    }

    .dashboard-box {
      position: relative;
      width: max-content;
      padding: 10px 20px;
      z-index: 1;
      font-size: 15px;
      text-align: center;

      .h-number {
        font-size: 30px;
        padding: 10px 0 5px;

        span {
          font-size: 15px;
        }
      }

      .h-text {
        font-size: 20px;
        margin-top: 7px;
      }

      i {
        font-size: 15px;
      }

      .icon-box {
        display: inline-flex;
        padding: 5px 0 15px 0;

        i {
          color: #ffffff;
          font-size: 30px;
          box-shadow: 0 4px 4px -2px gray;
          border-radius: 50%;
          padding: 10px;
        }

        i.cash {
          background: #5d87ff;
        }

        i.bill {
          background: #27c5da;
        }

        i.discount {
          background: #f9896b;
        }

        i.booking {
          background: #ffaf1d;
        }

        i.renter {
          background: #17dd95;
          // background: #ffa33a;
        }

        i.area {
          background: #4abeff;
        }

        .image-icon {
          box-shadow: 0 4px 4px -2px gray;
          border-radius: 50%;
          padding: 10px;
        }

        .image-icon.area {
          background: #4abeff;

          img {
            padding: 4px;
            width: 30px;
            object-fit: contain;
            object-position: center;
          }
        }
      }

      span.plus {
        font-size: 18px;
        color: rgb(45, 192, 0);
      }
    }

    .dashboard-box:before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 70%;
      border-left: 1px solid rgba(167, 167, 167, 0.507);
    }

    .dashboard-input {
      display: flex;
      align-items: center;
      justify-items: center;
      margin-right: 15px;
    }
  }
}

.gh {
  display: flex;
  justify-content: center;

  .in {
    background: rgba(230, 230, 230, 0.35);
    border-radius: 15px;
    padding: 20px 15px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: max-content;
    padding: 20px 15px;
    gap: 15px;
  }

  .b {
    padding-left: 10px;
    border-left: 1px solid rgba(167, 167, 167, 0.507);
  }
}
</style>